import { getSafelyWindow } from './safelyWindow';

export const getUserAgent = () => getSafelyWindow()?.navigator?.userAgent || '';

export const isAndroid = () => /android/gi.test(getUserAgent());

export const isIOS = () => {
  const navigator = getSafelyWindow()?.navigator;

  if (!navigator) {
    return false;
  }

  return (
    /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
  );
};

export const isWxMiniProgram = () =>
  /MicroMessenger/gi.test(getUserAgent()) &&
  /miniProgram/gi.test(getUserAgent());

export const isRealseeVRWebview = () => /realsee/gi.test(getUserAgent());
